<template>
  <div class="box">
    <div class="main-content flex column">
      <div class="pointsDetails-top flex align justify">
        <!-- 课程积分 -->
        <img class="icon1 pointer" @click="selectTheTypeOfTab('course')"
          :src="examScoreType == 'course' ? require('@/assets/viewPoints/checkCoursePoints.png') : require('@/assets/viewPoints/uncheckCoursePoints.png')" />
        <div class="separate"></div>
        <!-- 平时表现分 -->
        <img class="icon2 pointer" @click="selectTheTypeOfTab('usually')"
          :src="examScoreType == 'usually' ? require('@/assets/viewPoints/checkDailyPerformanceScore.png') : require('@/assets/viewPoints/uncheckDailyPerformanceScore.png')" />
        <div class="separate"></div>
        <!-- 期中考试分数 -->
        <img class="icon3 pointer" @click="selectTheTypeOfTab('mid')"
          :src="examScoreType == 'mid' ? require('@/assets/viewPoints/checkMidtermExamScore.png') : require('@/assets/viewPoints/uncheckMidtermExamScore.png')" />
        <div class="separate"></div>
        <!-- 期末考试分数 -->
        <img class="icon4 pointer" @click="selectTheTypeOfTab('final')"
          :src="examScoreType == 'final' ? require('@/assets/viewPoints/checkFinalExamScore.png') : require('@/assets/viewPoints/uncheckFinalExamScore.png')" />
        <div class="separate"></div>
        <!-- 其他考试分数 -->
        <img class="icon5 pointer" @click="selectTheTypeOfTab('other')"
          :src="examScoreType == 'other' ? require('@/assets/viewPoints/checkOtherExamScore.png') : require('@/assets/viewPoints/unCheckOtherExamScore.png')" />
      </div>
      <!-- 课程积分内容一部分开始 -->
      <div v-show="scoreType == 'coursePointsPage1'" class="pointsDetails-content">
        <!-- 选择器部分开始 -->
        <div class="flex" style="box-sizing: border-box">
          <!-- 班级选择器 -->
          <div class="flex align">
            <div class="selector-txt">班级</div>
            <el-cascader @change="classHandleChange" v-model="classValue" :options="classOptions"></el-cascader>
          </div>
          <!-- 课次选择器 -->
          <div class="flex align" style="margin-left: 50px">
            <div class="selector-txt">课次</div>
            <el-select @change="classTimesHandleChange" v-model="classNumberValue" placeholder="请选择">
              <el-option v-for="item in classNumberOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <!-- 姓名选择器 -->
          <div class="flex align" style="margin-left: 50px">
            <div class="selector-txt">姓名</div>
            <el-select @change="nameHandleChange" filterable v-model="nameValue" placeholder="请选择">
              <el-option v-for="item in nameOptions" :key="item.value" :label="item.label"
                :value="{ value: item.value, label: item.label }"> </el-option>
            </el-select>
          </div>
        </div>
        <!-- echart图表部分开始 -->
        <div class="flex" style="margin-top: 30px">
          <echartsPie :preData="preData[0]"></echartsPie>
          <echartsPie :preData="preData[1]"></echartsPie>
          <echartsPie :preData="preData[9]"></echartsPie>
        </div>
        <div class="flex spaceBetween">
          <div></div>
          <img @click="showPopDerive = true" class="btnDataExport" src="@/assets/viewPoints/iconDataExport.png" />
        </div>
        <!-- echart图表部分结束 -->
        <!-- 学生表格部分开始 -->
        <el-table :data="studentDataList" style="margin-top: 14px"
          :header-cell-style="{ background: '#EEEEEE', color: '#000000' }" stripe border height="calc(100vh - 580px)">
          <el-table-column align="center" prop="name" label="学生姓名"> </el-table-column>
          <el-table-column align="center" prop="account" label="学号"> </el-table-column>
          <el-table-column align="center" prop="grade" label="年级"> </el-table-column>
          <el-table-column align="center" prop="class" label="班级"> </el-table-column>
          <el-table-column align="center" prop="coursePoints" label="课程积分">
            <template slot-scope="scope"> {{ scope.row.coursePoints }}分 </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" label="查看详情">
            <template slot-scope="scope">
              <div @click="detail('coursePointsPage1', scope.row.name, '', scope.row.id)" class="detail pointer">查看详情
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 学生表格部分结束 -->
      </div>
      <!-- 课程积分内容一部分结束 -->
      <!-- 课程积分内容二部分开始 -->
      <div v-show="scoreType == 'coursePointsPage2'" class="pointsDetails-content">
        <!-- 选择器部分开始 -->
        <div class="flex" style="box-sizing: border-box">
          <!-- 班级选择器 -->
          <div class="flex align">
            <div class="selector-txt">班级</div>
            <el-cascader @change="classHandleChange" v-model="classValue" :options="classOptions"></el-cascader>
          </div>
          <!-- 课次选择器 -->
          <div class="flex align" style="margin-left: 50px">
            <div class="selector-txt">课次</div>
            <el-select @change="classTimesHandleChange" v-model="classNumberValue" placeholder="请选择">
              <el-option v-for="item in classNumberOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <!-- 姓名选择器 -->
          <div class="flex align" style="margin-left: 50px">
            <div class="selector-txt">姓名</div>
            <el-select @change="nameHandleChange" filterable v-model="nameValue" placeholder="请选择">
              <el-option v-for="item in nameOptions" :key="item.value" :label="item.label"
                :value="{ value: item.value, label: item.label }"> </el-option>
            </el-select>
          </div>
        </div>
        <!-- echart图表部分开始 -->
        <div class="flex" style="margin-top: 30px">
          <echartsPie :preData="preData[0]"></echartsPie>
          <echartsPie style="margin-left: 300px" :preData="preData[1]"></echartsPie>
        </div>
        <!-- echart图表部分结束 -->
        <!-- 学生表格部分开始 -->
        <el-table :data="studentDataList" style="margin-top: 14px"
          :header-cell-style="{ background: '#EEEEEE', color: '#000000' }" stripe border height="450">
          <el-table-column align="center" prop="name" label="学生姓名"> </el-table-column>
          <el-table-column align="center" prop="account" label="学号"> </el-table-column>
          <el-table-column align="center" prop="grade" label="年级"> </el-table-column>
          <el-table-column align="center" prop="class" label="班级"> </el-table-column>
          <el-table-column align="center" prop="beforeClassScore" label="课前准备"> </el-table-column>
          <el-table-column align="center" prop="middleClassScore" label="课堂学习"> </el-table-column>
          <el-table-column align="center" prop="afterClassScore" label="课后巩固"> </el-table-column>
          <el-table-column show-overflow-tooltip align="center" label="查看详情">
            <template slot-scope="scope">
              <div @click="detail('coursePointsPage1', scope.row.name, '', scope.row.id)" class="detail pointer">查看详情
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 学生表格部分结束 -->
      </div>
      <!-- 课程积分内容二部分结束 -->
      <!-- 课程积分内容三部分开始 -->
      <div v-show="scoreType == 'coursePointsPage3'" class="pointsDetails-content">
        <!-- 选择器部分开始 -->
        <div class="flex" style="box-sizing: border-box">
          <!-- 班级选择器 -->
          <div class="flex align">
            <div class="selector-txt">班级</div>
            <el-cascader @change="classHandleChange" v-model="classValue" :options="classOptions"></el-cascader>
          </div>
          <!-- 姓名选择器 -->
          <div class="flex align" style="margin-left: 50px">
            <div class="selector-txt">姓名</div>
            <el-select @change="nameHandleChange" filterable v-model="nameValue" placeholder="请选择">
              <el-option v-for="item in nameOptions" :key="item.value" :label="item.label"
                :value="{ value: item.value, label: item.label }"> </el-option>
            </el-select>
          </div>
        </div>
        <!-- 课次表格部分开始 -->
        <el-table :data="classPointsList" style="margin-top: 30px"
          :header-cell-style="{ background: '#EEEEEE', color: '#000000' }" stripe border height="650">
          <el-table-column align="center" prop="classNumberName" label="课次名称" width="700"> </el-table-column>
          <el-table-column align="center" prop="beforeClassScore" label="课前准备"> </el-table-column>
          <el-table-column align="center" prop="middleClassScore" label="课堂学习"> </el-table-column>
          <el-table-column align="center" prop="afterClassScore" label="课后巩固"> </el-table-column>
          <el-table-column show-overflow-tooltip align="center" label="查看详情">
            <template slot-scope="scope">
              <div @click="detail('coursePointsPage3', nameValue, scope.row.id)" class="detail pointer">查看详情</div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 课次表格部分结束 -->
      </div>
      <!-- 课程积分内容三部分结束 -->
      <!-- 课程积分内容四部分开始 -->
      <div v-show="scoreType == 'coursePointsPage4'" class="pointsDetails-content">
        <!-- 选择器部分开始 -->
        <div class="flex" style="box-sizing: border-box">
          <!-- 班级选择器 -->
          <div class="flex align">
            <div class="selector-txt">班级</div>
            <el-cascader @change="classHandleChange" v-model="classValue" :options="classOptions"></el-cascader>
          </div>
          <!-- 姓名选择器 -->
          <div class="flex align" style="margin-left: 50px">
            <div class="selector-txt">姓名</div>
            <el-select @change="nameHandleChange" filterable v-model="nameValue" placeholder="请选择">
              <el-option v-for="item in nameOptions" :key="item.value" :label="item.label"
                :value="{ value: item.value, label: item.label }"> </el-option>
            </el-select>
          </div>
          <!-- 课次选择器 -->
          <div class="flex align" style="margin-left: 50px">
            <div class="selector-txt">课次</div>
            <el-select @change="classTimesHandleChange" v-model="classNumberValue" placeholder="请选择">
              <el-option v-for="item in classNumberOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div style="height: 680px; overflow: scroll">
          <!-- 教学实施部分开始 -->
          <div style="margin-top: 30px">
            <div class="resourceList-h1Box">
              <div class="resourceList-block"></div>
              <div class="resourceList-h1">教学实施</div>
            </div>
            <!-- 课前准备部分开始 -->
            <div style="margin-top: 3px">
              <div class="resourceList-h2Box">
                <div class="resourceList-round"></div>
                <div class="resourceList-h2">课前准备</div>
              </div>
              <el-table :data="beforeClassList" :show-header="false" :row-style="{ height: '30px' }" fit>
                <el-table-column show-overflow-tooltip align="center" prop="name"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="types"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="created"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="score"> </el-table-column>
              </el-table>
            </div>
            <!-- 课前准备部分结束 -->
            <!-- 课堂教学部分开始 -->
            <div style="margin-top: 3px">
              <div class="resourceList-h2Box">
                <div class="resourceList-round"></div>
                <div class="resourceList-h2">课堂教学</div>
              </div>
              <el-table :data="middleClassList" :show-header="false" :row-style="{ height: '30px' }" fit>
                <el-table-column show-overflow-tooltip align="center" prop="name"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="types"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="created"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="score"> </el-table-column>
              </el-table>
            </div>
            <!-- 课堂教学部分结束 -->
            <!-- 课后巩固部分开始 -->
            <div style="margin-top: 3px">
              <div class="resourceList-h2Box">
                <div class="resourceList-round"></div>
                <div class="resourceList-h2">课后巩固</div>
              </div>
              <el-table :data="afterClassList" :show-header="false" :row-style="{ height: '30px' }" fit>
                <el-table-column show-overflow-tooltip align="center" prop="name"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="types"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="created"> </el-table-column>
                <el-table-column show-overflow-tooltip align="center" prop="score"> </el-table-column>
              </el-table>
            </div>
            <!-- 课后巩固部分结束 -->
          </div>
          <!-- 教学实施部分结束 -->
        </div>
      </div>
      <!-- 课程积分内容四部分结束 -->
      <!-- 考试分数部分开始 -->
      <div v-show="scoreType == 'testPaperForm'" class="pointsDetails-content">
        <!-- 选择器部分开始 -->
        <div class="flex" style="box-sizing: border-box">
          <!-- 班级选择器 -->
          <div class="flex align">
            <div class="selector-txt">班级</div>
            <el-cascader @change="classHandleChange" v-model="classValue" :options="classOptions"></el-cascader>
          </div>
          <!-- 姓名选择器 -->
          <div class="flex align" style="margin-left: 50px">
            <div class="selector-txt">姓名</div>
            <el-select @change="nameHandleChange" filterable v-model="nameValue" placeholder="请选择">
              <el-option v-for="item in nameOptions" :key="item.value" :label="item.label"
                :value="{ value: item.value, label: item.label }"> </el-option>
            </el-select>
          </div>
          <!-- 日期选择器 -->
          <div class="flex align" style="margin-left: 50px">
            <div class="selector-txt">日期</div>
            <el-date-picker @change="dateHandleChange" :default-time="['00:00:00', '23:59:59']" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss" v-model="dateValue" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
          </div>
        </div>
        <!-- echart图表部分开始 -->
        <div class="flex" style="margin-top: 30px">
          <echartsPie :preData="preData[7]"></echartsPie>
          <echartsPie style="margin-left: 147px" :preData="preData[8]"></echartsPie>
        </div>
        <!-- echart图表部分结束 -->
        <!-- 考试分数上传 -->
        <div v-show="editableOrNot" class="flex spaceBetween">
          <div></div>
          <img v-if="examScoreType != 'other'" class="uploadExamScores pointer" @click="uploadTable('finalExamination')"
            src="@/assets/viewPoints/uploadExamScores.png" />
        </div>
        <!-- 考试分数导出表格 -->
        <div v-if="examScoreType == 'other'" class="flex spaceBetween">
          <div></div>
          <img @click="btnExamDataExport" class="btnDataExport" src="@/assets/viewPoints/iconDataExport.png" />
        </div>
        <!-- 学生表格部分开始 -->
        <el-table :data="studentDataList" style="margin-top: 14px"
          :header-cell-style="{ background: '#EEEEEE', color: '#000000' }" stripe border height="calc(100vh - 450px)">
          <el-table-column align="center" prop="name" label="学生姓名"> </el-table-column>
          <el-table-column align="center" prop="account" label="学号"> </el-table-column>
          <el-table-column align="center" prop="grade" label="年级"> </el-table-column>
          <el-table-column align="center" prop="class" label="班级"> </el-table-column>
          <el-table-column align="center" prop="numberOfExams" label="考试次数">
            <template slot-scope="scope"> {{ scope.row.numberOfExams }}次 </template>
          </el-table-column>
          <el-table-column align="center" prop="totalScore" label="总分">
            <template slot-scope="scope"> {{ scope.row.totalScore }}分 </template>
          </el-table-column>
          <el-table-column align="center" prop="averageScore" label="平均分">
            <template slot-scope="scope"> {{ scope.row.averageScore }}分 </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" label="查看详情">
            <template slot-scope="scope">
              <div @click="viewDetailsOfTheTestPaper(scope.row.id)" class="detail pointer">查看详情</div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 学生表格部分结束 -->
      </div>
      <!-- 考试分数部分结束 -->
      <!-- 考试详情部分开始 -->
      <div v-show="scoreType == 'examinationData'" class="pointsDetails-content">
        <!-- 选择器部分开始 -->
        <div class="flex" style="box-sizing: border-box">
          <!-- 班级选择器 -->
          <div class="flex align">
            <div class="selector-txt">班级</div>
            <el-cascader @change="classHandleChange" v-model="classValue" :options="classOptions"></el-cascader>
          </div>
          <!-- 姓名选择器 -->
          <div class="flex align" style="margin-left: 50px">
            <div class="selector-txt">姓名</div>
            <el-select @change="nameHandleChange" filterable v-model="nameValue" placeholder="请选择">
              <el-option v-for="item in nameOptions" :key="item.value" :label="item.label"
                :value="{ value: item.value, label: item.label }"> </el-option>
            </el-select>
          </div>
        </div>
        <!-- 课次表格部分开始 -->
        <el-table :data="examDataList" style="margin-top: 30px"
          :header-cell-style="{ background: '#EEEEEE', color: '#000000' }" stripe border height="650">
          <el-table-column align="center" prop="name" label="作业名称"> </el-table-column>
          <el-table-column align="center" prop="submissionTime" label="提交时间"> </el-table-column>
          <el-table-column align="center" prop="answerDuration" label="答题时长"> </el-table-column>
          <el-table-column align="center" prop="correctNumber" label="正确题数"> </el-table-column>
          <el-table-column align="center" prop="correctRate" label="正确率"> </el-table-column>
          <el-table-column align="center" prop="getPoints" label="分数"> </el-table-column>
          <el-table-column show-overflow-tooltip align="center" label="查看详情">
            <template slot-scope="scope">
              <div @click="viewAnswerTheTestPaperDetails(scope.row)" class="detail pointer">查看详情</div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 课次表格部分结束 -->
      </div>
      <!-- 考试详情部分结束 -->
    </div>
    <!-- 分数上传弹窗部分开始 -->
    <div v-show="showBatchUpload" class="pop-batchUpload">
      <div v-loading="loading" element-loading-text="拼命上传中..." element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.7)" class="resourcesBatchUpload-content">
        <img @click="showBatchUpload = false" class="btnClose pointer" src="../../assets/btnClose.png" />
        <div class="batchUpload-title">{{ batchUploadTitle }}</div>
        <div class="flex spaceBetween" style="margin-top: 23px">
          <div></div>
          <img @click="templateDownload" class="templateDownload pointer" src="@/assets/classManagement/cm6.png" />
        </div>
        <!-- 表格上传 -->
        <div class="flex spaceBetween" style="margin-top: 20px">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">表格上传:</div>
          </div>
          <div class="main-content-right">
            <div class="boxImport">
              <img class="boxImport pointer" @click="btnScoreImport" src="@/assets/classManagement/cm7.png" />
              <div v-show="showImportTips" class="submitSuccessfully flex align justify">
                <img class="submitSuccessfullyImg" src="@/assets/submitSuccessfully.png" />
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify pointer" style="margin-top: 17px">
          <div @click="btnPopAffirm" class="btnPopAffirm">确认</div>
        </div>
      </div>
    </div>
    <!-- 分数上传弹窗部分结束 -->
    <!-- 数据导出弹窗部分开始 -->
    <div v-show="showPopDerive" class="pop-batchUpload">
      <div v-loading="loading" element-loading-text="导出中..." element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.7)" class="resourcesBatchUpload-content">
        <img @click="showPopDerive = false" class="btnClose pointer" src="../../assets/btnClose.png" />
        <div class="batchUpload-title">选择课次</div>
        <div class="classNumberTxtBox flex column">
          <div @click="selectAllClass" class="classNumberTxtBoxItem flex align pointer">
            <img v-show="checkAll" class="gradediv_classimg" src="../../assets/classManagement/cm11.png" />
            <img v-show="!checkAll" class="gradediv_classimg" src="../../assets/classManagement/cm10.png" />
            <div class="classNumberTxt">全部课次</div>
          </div>
          <div @click="selectClassNum(item)" v-for="(item, index) in classNumberOptions1" :key="item.value"
            class="classNumberTxtBoxItem flex align pointer">
            <img v-if="checkedClassNumber.indexOf(item) !== -1" class="gradediv_classimg"
              src="../../assets/classManagement/cm11.png" />
            <img v-else class="gradediv_classimg" src="../../assets/classManagement/cm10.png" />
            <div class="classNumberTxt">{{ item.label }}</div>
          </div>
        </div>
        <div class="flex justify pointer" style="margin-top: 17px">
          <div @click="btnDataExport" class="btnPopAffirm">确认</div>
        </div>
      </div>
    </div>
    <!-- 数据导出弹窗部分结束 -->
    <!-- 考试作答数据弹窗部分开始 -->
    <div v-if="showAnswerTheTestPaperDetails" class="pop-answerTheTestPaperDetails flex align justify">
      <div class="answerTheTestPaperDetails-box flex column">
        <img @click="showAnswerTheTestPaperDetails = false" class="btnClose pointer" src="../../assets/btnClose.png" />
        <!-- 作业信息 -->
        <div>
          <div class="answerTheTestPaperDetails-title">作业信息</div>
          <div class="testPaperInformation-box">
            <div class="flex">
              <div class="flex" style="width: 50%">
                <div class="testPaperInformationTxt" style="font-weight: 600">作业名称:</div>
                <div class="testPaperInformationTxt">{{ testPaper.name }}</div>
              </div>
              <div class="flex" style="width: 50%">
                <div class="testPaperInformationTxt" style="font-weight: 600">查看答案时机:</div>
                <div class="testPaperInformationTxt">{{ testPaper.answer_limitTxt }}</div>
              </div>
            </div>
            <div class="flex">
              <div class="flex" style="width: 50%">
                <div class="testPaperInformationTxt" style="font-weight: 600">考试起止时间:</div>
                <div class="testPaperInformationTxt">{{ testPaper.start_StopTime }}</div>
              </div>
              <div class="flex" style="width: 50%">
                <div class="testPaperInformationTxt" style="font-weight: 600">作业用途:</div>
                <div class="testPaperInformationTxt">{{ testPaper.examUsage }}</div>
              </div>
            </div>
            <div class="flex">
              <div class="flex" style="width: 33.33%">
                <div class="testPaperInformationTxt" style="font-weight: 600">作业题数:</div>
                <div class="testPaperInformationTxt">{{ testPaper.num_item }}</div>
              </div>
              <div class="flex" style="width: 33.33%">
                <div class="testPaperInformationTxt" style="font-weight: 600">考试时长:</div>
                <div class="testPaperInformationTxt">{{ testPaper.testDuration }}</div>
              </div>
              <div class="flex" style="width: 33.33%">
                <div class="testPaperInformationTxt" style="font-weight: 600">作业满分:</div>
                <div class="testPaperInformationTxt">{{ testPaper.score }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 作业内容 -->
        <div class="flex column" style="flex: 1; overflow: auto">
          <div class="answerTheTestPaperDetails-title1">作业内容</div>
          <div style="flex: 1; overflow: auto">
            <div class="exampleList" v-for="(item, index) in testPaper.exam_items" :key="index">
              <!-- 题干 -->
              <div class="flex align spaceBetween">
                <div class="flex align">
                  <div class="questionNo">{{ index + 1 }}</div>
                  <div class="topicType">{{ item.exam_item.types }}</div>
                </div>
                <div class="flex align">
                  <div class="score-txt">分值:</div>
                  <div class="score-inputFrame flex justify">
                    <input disabled v-model="item.exam_item.getScore" class="score-input" type="text" />
                  </div>
                </div>
              </div>
              <div class="flex align">
                <div class="stem">{{ item.exam_item.content }}</div>
              </div>
              <!-- 选项 -->
              <div
                v-if="item.exam_item.types == '单选题' || item.exam_item.types == '多选题' || item.exam_item.types == '判断题'"
                class="exampleList-option">
                <div v-for="(item, index) in item.exam_item.options" :key="index">
                  <div class="exampleList-option-txt">{{ optionOrder[index] }}.{{ item }}</div>
                </div>
              </div>
              <!-- 答案 -->
              <div
                v-if="item.exam_item.types == '单选题' || item.exam_item.types == '多选题' || item.exam_item.types == '判断题'"
                class="answer flex align">
                <div class="answer-txt">答案:</div>
                <div class="answer-English">{{ item.exam_item.answerTxt.join(",") }}</div>
              </div>
              <div v-if="item.exam_item.types == '填空题'" class="answer flex align">
                <div class="answer-txt">答案:</div>
                <div class="blankAnswer" v-for="(item, index) in item.exam_item.options" :key="index">第{{ index + 1 }}空:
                  {{
            item }}</div>
              </div>
              <!-- 学生答案 -->
              <div class="answer flex align">
                <div class="answer-txt">学生答案:</div>
                <div class="answer-English">{{ item.exam_item.studentAnswer }}</div>
              </div>
              <!-- 解析 -->
              <div class="answer flex">
                <div class="answer-txt">解析:</div>
                <div class="answer-English">{{ item.exam_item.comment }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 考试作答数据弹窗部分结束 -->
  </div>
</template>

<script>
import { obtainTeacherTeachingClass, courseLearningRecords, resourceList, getScoreList, getStudentExamScore, getPersonalTestPaperData } from "@/api";
import { base64toFile, filetoBase64 } from "@/utils/util.js";
import echartsPie from "@/components/echarts_pie";
import { Toast } from "vant";
import axios from "axios";
import store from "@/store";
export default {
  data() {
    return {
      showPopDerive: false,
      checkAll: false,
      isIndeterminate: true,
      checkedClassNumber: [],
      editableOrNot: true, // 是否可编辑
      identity: "", // 登录身份
      scoreType: "coursePointsPage1", // 积分类型 课程积分coursePoints 平时表现分dailyPerformanceScore 期中考试分数midtermExamScore 期末考试分数finalExamScore
      classOptions: [], // 班级选项
      classValue: ["2021级", 1], // 默认班级
      classNumberOptions: [
        {
          value: 0,
          label: "全部课次",
        },
      ],
      classNumberOptions1: [],
      // 课次选项
      classNumberValue: 0, // 默认课次
      nameOptions: [
        {
          value: 0,
          label: "全部学生",
        },
      ], // 姓名选项
      nameValue: "", // 默认姓名
      nameID: "", // 默认姓名id
      studentDataList: [], // 学生表格列表数据
      classPointsList: [], // 课次得分列表数据
      beforeClassList: [], // 课前准备列表
      middleClassList: [], // 课堂教学列表
      afterClassList: [], // 课后巩固列表
      testPapersList: [], // 作业列表
      conversionData: "", // 资源转换后的数据
      combinedData: [], // 资源和试题接口组合的数据
      showBatchUpload: false, // 是否展示分数上传弹窗
      batchUploadTitle: "", // 分数上传弹窗标题
      formFile: "", // 上传表格的Base64
      loading: false, // 加载状态
      showImportTips: false, // 导入后的状态
      resourceTotal: 0, // 资源总数
      examitemTotal: 0, // 试题总数
      examTotal: 0, // 作业总数
      scoreList: [], // 表现分、期中考试分数、期末考试分数列表
      averageScore1: 0, // 平时表现分平均分
      averageScore2: 0, // 期中考试分数平均分
      averageScore3: 0, // 期末考试分数平均分
      deepCopyPreData: "", // 深拷贝后的echarts数据=>用于重新赋值
      dateValue: [], // 默认日期
      // echart的数据
      preData: [
        {
          title: "资源统计",
          show: true,
          typeList: [
            { value: 0, name: "视频资源" },
            { value: 0, name: "音频资源" },
            { value: 0, name: "文档资源" },
            { value: 0, name: "图片资源" },
            { value: 0, name: "网页链接" },
          ],
          countLength: "{totalText|共计}" + "\n" + "{totalText|" + 0 + "个}",
        },
        {
          title: "习题统计",
          show: true,
          typeList: [
            { value: 0, name: "单选题" },
            { value: 0, name: "多选题" },
            { value: 0, name: "判断题" },
            { value: 0, name: "简答题" },
          ],
          countLength: "{totalText|共计}" + "\n" + "{totalText|" + 0 + "题}",
        },
        {
          title: "课程进度",
          show: true,
          typeList: [
            { value: 0, name: "0~59%" },
            { value: 0, name: "60~79%" },
            { value: 0, name: "80~89%" },
            { value: 0, name: "90~100%" },
          ],
          countLength: "{totalText|平均进度}" + "\n" + "{totalText|" + 0 + "%}",
        },
        {
          title: "分数统计",
          show: true,
          typeList: [
            { value: 0, name: "0~59分" },
            { value: 0, name: "60~69分" },
            { value: 0, name: "70~79分" },
            { value: 0, name: "80~89分" },
            { value: 0, name: "90~100分" },
          ],
          countLength: "{totalText|平均分}" + "\n" + "{totalText|" + 0 + "分}",
        },
        {
          title: "优良率统计",
          show: true,
          typeList: [
            { value: 0, name: "不及格" },
            { value: 0, name: "一般" },
            { value: 0, name: "中等" },
            { value: 0, name: "良好" },
            { value: 0, name: "优秀" },
          ],
          countLength: "{totalText|及格率}" + "\n" + "{totalText|" + 0 + "%}",
        },
        {
          title: "分数统计",
          show: true,
          typeList: [
            { value: 0, name: "0~59分" },
            { value: 0, name: "60~69分" },
            { value: 0, name: "70~79分" },
            { value: 0, name: "80~89分" },
            { value: 0, name: "90~100分" },
          ],
          countLength: "{totalText|平均分}" + "\n" + "{totalText|" + 0 + "分}",
        },
        {
          title: "优良率统计",
          show: true,
          typeList: [
            { value: 0, name: "不及格" },
            { value: 0, name: "一般" },
            { value: 0, name: "中等" },
            { value: 0, name: "良好" },
            { value: 0, name: "优秀" },
          ],
          countLength: "{totalText|及格率}" + "\n" + "{totalText|" + 0 + "%}",
        },
        {
          title: "分数统计",
          show: true,
          typeList: [
            { value: 0, name: "0~59分" },
            { value: 0, name: "60~69分" },
            { value: 0, name: "70~79分" },
            { value: 0, name: "80~89分" },
            { value: 0, name: "90~100分" },
          ],
          countLength: "{totalText|平均分}" + "\n" + "{totalText|" + 0 + "分}",
        },
        {
          title: "优良率统计",
          show: true,
          typeList: [
            { value: 0, name: "不及格" },
            { value: 0, name: "一般" },
            { value: 0, name: "中等" },
            { value: 0, name: "良好" },
            { value: 0, name: "优秀" },
          ],
          countLength: "{totalText|及格率}" + "\n" + "{totalText|" + 0 + "%}",
        },
        {
          title: "作业统计",
          show: true,
          typeList: [
            { value: 0, name: "手动选题" },
            { value: 0, name: "自动选题" },
          ],
          countLength: "{totalText|共计}" + "\n" + "{totalText|" + 0 + "个}",
        },
      ],
      examScoreType: "course",
      teachingClass: [], // 获取老师所有授课班级
      currentGrade: "", // 当前年级
      currentClass: "", // 当前班级
      exam_ids: "", // 作业id
      examList: [], // 作业列表
      examDataList: [], // 作业数据列表
      showAnswerTheTestPaperDetails: false, // 考试作答数据弹窗
      testPaper: {}, // 作业详情
      optionOrder: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
      answerRecord: [], // 答题记录
    };
  },
  components: { echartsPie },
  created() {
    // 获取统计图数据
    let params = {
      lesson_id: this.$store.state.courseDetails.id,
      lesson_item_id: 0,
      types: "",
      page: 1,
      num: 10000,
    };
    this.publicClassResources(params);
    this.editableOrNot = this.$store.state.editableOrNot; // 获取是否可编辑状态
    // 获取登录身份
    this.identity = this.$store.state.loginRecord.data.datas.identity;
    this.deepCopyPreData = JSON.stringify(this.preData); // 深拷贝的echarts数据=>用于重新赋值
    // 调用获取老师授课班级列表接口
    let params1 = { lesson_id: this.$store.state.courseDetails.id };
    obtainTeacherTeachingClass(params1).then((res) => {
      this.teachingClass = res.data.datas; // 获取老师所有授课班级
      this.currentGrade = res.data.datas[0].grade; // 获取当前年级
      this.currentClass = res.data.datas[0].name; // 获取当前班级
      let groupedData = res.data.datas.reduce((groups, item) => {
        (groups[item.grade] = groups[item.grade] || []).push(item);
        return groups;
      }, {});
      this.classValue[0] = res.data.datas[0].grade;
      this.classValue[1] = res.data.datas[0].id;
      this.classId = res.data.datas[0].id;
      for (let key in groupedData) {
        for (let j in groupedData[key]) {
          let publicRes = groupedData[key];
          publicRes[j].value = publicRes[j].id;
          publicRes[j].label = publicRes[j].name;
        }
        this.classOptions.push({
          value: key,
          label: key,
          children: groupedData[key],
        });
      }
      // 调用获取数据方法
      this.publicGettingDataFunc("course");
    });
    // 获取当前课程全部课次的数据
    for (let i = 0; i < this.$store.state.classListRecord.length; i++) {
      // 获取课次选择器数据
      this.classNumberOptions.push({
        value: this.$store.state.classListRecord[i].id,
        label: this.$store.state.classListRecord[i].name,
      });
      // 获取课次选择器数据
      this.classNumberOptions1.push({
        value: this.$store.state.classListRecord[i].id,
        label: "课次" + (i + 1) + " " + this.$store.state.classListRecord[i].name,
      });
    }
    this.dateValue[0] = this.getCurrentSemesterStart();
    this.dateValue[1] = this.formatDate(new Date());
  },
  methods: {
    // 作业导出表格功能
    btnExamDataExport() {
      import("@/vendor/Export2Excel").then((excel) => {
        const tHeader = ["学生姓名", "学号", "年级", "班级", "考试次数", "总分", "平均分"];
        const filterVal = ["name", "account", "grade", "class", "numberOfExams", "totalScore", "averageScore"];
        const list = this.studentDataList;
        const data = this.formatJson1(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          autoWidth: true,
          filename: "其他考试分数表",
        });
      });
    },
    formatJson1(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === "timestamp") {
            import("@/vendor/Export2Excel").then((excel) => {
              return excel.parseTime(v[j]);
            });
          } else {
            return v[j];
          }
        })
      );
    },
    // 查看作业作答详情
    viewAnswerTheTestPaperDetails(item) {
      console.log(item);
      if (item.answer_limit == "after") {
        item.answer_limitTxt = "交卷后可查看答案";
      } else if (item.answer_limit == "no") {
        item.answer_limitTxt = "不可查看答案";
      } else if (item.answer_limit == "time") {
        const formattedDate = item.answer_time.split("T")[0];
        item.answer_limitTxt = formattedDate + "后"; // 获取查看答案时机
      }
      let startTime = item.time_begin.split("T")[0];
      let endTime = item.time_end.split("T")[0];
      item.start_StopTime = startTime + "—" + endTime; // 获取考试起止时间
      if (item.usage == "usually") {
        item.examUsage = "平时考试";
      } else if (item.usage == "mid") {
        item.examUsage = "期中考试";
      } else if (item.usage == "final") {
        item.examUsage = "期末考试";
      } else if (item.usage == "other") {
        item.examUsage = "其他考试"; // 获取考试用途
      }
      if (item.time_total == 0) {
        item.testDuration = "不限时";
      } else {
        item.testDuration = item.time_total + "分钟";
      }
      // 作业数据
      for (let i = 0; i < item.exam_items.length; i++) {
        let exam = item.exam_items[i];
        let examItem = exam.exam_item;
        examItem.getScore = 0;
        examItem.answerTxt = examItem.answer.map((num) => String.fromCharCode(65 + num));
        if (examItem.types == "truefalse") {
          examItem.options[0] = "正确";
          examItem.options[1] = "错误";
        }
        if (examItem.types == "single") {
          examItem.types = "单选题";
        } else if (examItem.types == "multi") {
          examItem.types = "多选题";
        } else if (examItem.types == "truefalse") {
          examItem.types = "判断题";
        } else if (examItem.types == "answer") {
          examItem.types = "简答题";
        } else if (examItem.types == "blank") {
          examItem.types = "填空题";
        }
        for (let j = 0; j < this.answerRecord.length; j++) {
          let answerRecord = this.answerRecord[j];
          if (exam.id == answerRecord.link_exam_item_id) {
            examItem.getScore = answerRecord.score; // 学生答案得分
            if (examItem.types == "单选题" || examItem.types == "多选题" || examItem.types == "判断题") {
              examItem.studentAnswer = answerRecord.answer
                .split(",") // 分割字符串为数组 ["2", "3", "1"]
                .map((num) => String.fromCharCode(65 + parseInt(num))) // 转换为字母 ["C", "D", "B"]
                .sort() // 排序 ["B", "C", "D"]
                .join(","); // 合并为字符串 "B,C,D" // 学生答案
            } else if (examItem.types == "填空题") {
              examItem.studentAnswer = answerRecord.answer
                .split("|")
                .map((part, index) => `第${index + 1}空:${part || "空白"}`)
                .join(" ");
            }
          }
        }
      }
      this.testPaper = item; // 获取作业详情
      this.showAnswerTheTestPaperDetails = true;
    },
    // 查看作业
    viewDetailsOfTheTestPaper(id) {
      // 调用获取个人作业数据详情
      let data = {
        user_id: id,
        begin: this.dateValue[0],
        end: this.dateValue[1],
        usage: this.examScoreType,
        lesson_id: this.$store.state.courseDetails.id,
        exam_ids: this.exam_ids,
      };
      getPersonalTestPaperData(data).then((res) => {
        this.scoreType = "examinationData";
        let scoreData = res.data.datas; // 学生评分数据
        this.answerRecord = scoreData; // 答题记录
        let examDataList = [...this.examList];
        for (let i = 0; i < examDataList.length; i++) {
          let exam = examDataList[i];
          let num = 0;
          exam.submissionTime = "暂无提交记录"; // 初始化提交时间
          exam.answerDuration = "0秒"; // 初始化答题时间
          exam.correctNumber = `${num}/${exam.num_item}`; // 初始化正确题数
          exam.correctRate = "0%"; // 初始化正确率
          exam.getPoints = 0; // 初始化得分
          for (let j = 0; j < scoreData.length; j++) {
            let record = scoreData[j];
            if (exam.id == record.resource_id && record.link_exam_item_id == 0) {
              exam.submissionTime = record.updated.split("T")[0]; // 作业提交时间
              exam.answerDuration = this.formatSeconds(record.duration); // 答题时间
            } else if (exam.id == record.resource_id && record.link_exam_item_id != 0) {
              exam.getPoints += record.score; // 累计得分
              if (record.score >= record.score_full) {
                exam.correctNumber = `${++num}/${exam.num_item}`; // 正确数
                exam.correctRate = ((num / exam.num_item) * 100).toFixed(1) + "%"; // 正确率
              }
            }
          }
        }
        this.examDataList = [];
        this.examDataList = JSON.parse(JSON.stringify(examDataList));
        // console.log(this.examDataList, examDataList);
      });
    },
    // 公共获取数据方法
    publicGettingDataFunc(type) {
      this.preData = JSON.parse(this.deepCopyPreData); // 重置echarts图表数据
      if (type == "course") {
        // 清空姓名选择器数据
        this.nameOptions = [
          {
            value: 0,
            label: "全部学生",
          },
        ];
        this.studentDataList = []; // 清空学生表格数据
        this.classPointsList = []; // 清空课次得分列表数据
        // 调用课次习题学生记录接口
        let params1 = { lesson_id: this.$store.state.courseDetails.id, class_id: this.classValue[1], types: "" };
        courseLearningRecords(params1).then((res) => {
          if (this.scoreType == "coursePointsPage3") {
            for (let i in res.data.ext.users) {
              // 获取姓名选择器数据
              this.nameOptions.push({
                value: res.data.ext.users[i].id,
                label: res.data.ext.users[i].name,
              });
            }
            // 获取当前课程全部课次的数据
            this.classPointsList = this.$store.state.classListRecord;
            for (let i = 0; i < this.classPointsList.length; i++) {
              this.classPointsList[i].classNumberName = "课次" + (i + 1) + " " + this.classPointsList[i].name;
              this.classPointsList[i].beforeClassScore = 0; // 课前准备积分
              this.classPointsList[i].middleClassScore = 0; // 课堂学习积分
              this.classPointsList[i].afterClassScore = 0; // 课后巩固积分
              for (let j in res.data.ext.lesson_user) {
                if (this.nameID == res.data.ext.lesson_user[j].user_id) {
                  let publicRes = res.data.ext.lesson_user[j];
                  if (this.classPointsList[i].id == publicRes.lesson_item_id) {
                    if (publicRes.usage == "front") {
                      this.classPointsList[i].beforeClassScore += publicRes.score; // 获取课前准备积分
                    } else if (publicRes.usage == "middle") {
                      this.classPointsList[i].middleClassScore += publicRes.score; // 获取课堂学习积分
                    } else if (publicRes.usage == "back") {
                      this.classPointsList[i].afterClassScore += publicRes.score; // 获取课后巩固积分
                    }
                  }
                }
              }
            }
          } else {
            // 获取学生表格数据
            for (let i in res.data.ext.users) {
              // 获取姓名选择器数据
              this.nameOptions.push({
                value: res.data.ext.users[i].id,
                label: res.data.ext.users[i].name,
              });
              // 获取学生数据列表数据
              let publicRes = res.data.ext.users[i];
              publicRes.grade = res.data.ext.class.grade; // 获取年级
              publicRes.class = res.data.ext.class.name; // 获取班级
              publicRes.beforeClassScore = 0; // 课前准备积分
              publicRes.middleClassScore = 0; // 课堂学习积分
              publicRes.afterClassScore = 0; // 课后巩固积分
              publicRes.coursePoints = 0; // 课程积分
              for (let j in res.data.ext.lesson_user) {
                if (publicRes.id == res.data.ext.lesson_user[j].user_id) {
                  if (this.classNumberValue == 0) {
                    publicRes.coursePoints += res.data.ext.lesson_user[j].score; // 计算全部课次课程积分
                  } else {
                    if (this.classNumberValue == res.data.ext.lesson_user[j].lesson_item_id) {
                      publicRes.coursePoints += res.data.ext.lesson_user[j].score; // 计算单个课次课程积分
                      if (res.data.ext.lesson_user[j].usage == "front") {
                        publicRes.beforeClassScore += res.data.ext.lesson_user[j].score; // 获取课前准备积分
                      } else if (res.data.ext.lesson_user[j].usage == "middle") {
                        publicRes.middleClassScore += res.data.ext.lesson_user[j].score; // 获取课堂学习积分
                      } else if (res.data.ext.lesson_user[j].usage == "back") {
                        publicRes.afterClassScore += res.data.ext.lesson_user[j].score; // 获取课后巩固积分
                      }
                    }
                  }
                }
              }
              if (this.nameValue == "" || this.nameValue == "全部学生") {
                this.studentDataList = res.data.ext.users; // 获取全部学生表格数据
              } else {
                for (let i in res.data.ext.users) {
                  // 获取单个学生表格数据
                  if (this.nameValue == res.data.ext.users[i].name) {
                    this.studentDataList = res.data.ext.users.filter((item) => item.name === this.nameValue);
                  }
                }
              }
            }
          }
        });
      } else {
        this.nameOptions = [];
        // 调用获取作业评分统计接口
        let data = {
          class_id: this.classId,
          lesson_id: this.$store.state.courseDetails.id,
          begin: this.dateValue[0],
          end: this.dateValue[1],
          usage: type,
        };
        if (type == "usually") {
          data.ext_type = "active";
        } else if (type == "mid") {
          data.ext_type = "middle";
        } else if (type == "final") {
          data.ext_type = "back";
        }
        getStudentExamScore(data).then((res) => {
          this.examList = res.data.datas.exams; // 获取作业列表
          this.exam_ids = res.data.datas.exams.map((item) => item.id).join(","); // 获取作业id
          let scoreData = res.data.datas; // 学生评分数据
          let studentList = scoreData.users; //学生列表
          this.averageScore3 = 0; // 期末考试分平均分
          for (let i in studentList) {
            // 获取姓名选择器数据
            this.nameOptions.push({
              value: studentList[i].id,
              label: studentList[i].name,
            });
          }
          for (let i = 0; i < studentList.length; i++) {
            studentList[i].grade = this.currentGrade; // 获取年级
            studentList[i].class = this.currentClass; // 获取班级
            studentList[i].numberOfExams = 0; // 考试次数
            studentList[i].totalScore = 0; // 总分
            studentList[i].averageScore = 0; // 平均分
            let examList = [...scoreData.ext_scores, ...scoreData.score_exam];
            for (let j = 0; j < examList.length; j++) {
              if (studentList[i].id == examList[j].user_id) {
                studentList[i].numberOfExams++; // 获取考试次数
                studentList[i].totalScore += Number(examList[j].score); // 获取总分
                studentList[i].averageScore = Number((studentList[i].totalScore / studentList[i].numberOfExams).toFixed(1)); // 计算平均分
              }
            }
            if (studentList[i].averageScore >= 0 && studentList[i].averageScore <= 59) {
              this.preData[7].typeList[0].value++;
              this.preData[8].typeList[0].value++;
            } else if (studentList[i].averageScore >= 60 && studentList[i].averageScore <= 69) {
              this.preData[7].typeList[1].value++;
              this.preData[8].typeList[1].value++;
            } else if (studentList[i].averageScore >= 70 && studentList[i].averageScore <= 79) {
              this.preData[7].typeList[2].value++;
              this.preData[8].typeList[2].value++;
            } else if (studentList[i].averageScore >= 80 && studentList[i].averageScore <= 89) {
              this.preData[7].typeList[3].value++;
              this.preData[8].typeList[3].value++;
            } else if (studentList[i].averageScore >= 90 && studentList[i].averageScore <= 100) {
              this.preData[7].typeList[4].value++;
              this.preData[8].typeList[4].value++;
            }
            // 计算期末考试分平均分
            this.averageScore3 += studentList[i].averageScore;
            // 计算期末考试分及格率
            let passRate3 = this.roundFun(((this.preData[7].typeList[1].value + this.preData[7].typeList[2].value + this.preData[7].typeList[3].value + this.preData[7].typeList[4].value) / studentList.length) * 100, 1);
            this.preData[7].countLength = "{totalText|平均分}" + "\n" + "{totalText|" + this.roundFun(this.averageScore3 / studentList.length, 1) + " 分}";
            this.preData[8].countLength = "{totalText|及格率}" + "\n" + "{totalText|" + passRate3 + " %}";
          }
          if (this.nameValue == "" || this.nameValue == "全部学生") {
            this.studentDataList = studentList; // 获取全部学生表格数据
          } else {
            for (let i in studentList) {
              // 获取单个学生表格数据
              if (this.nameValue == studentList[i].name) {
                this.studentDataList = studentList.filter((item) => item.name === this.nameValue);
              }
            }
          }
        });
      }
    },
    // 格式化时间
    formatSeconds(seconds) {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins}分${secs.toString().padStart(2, "0")}秒`;
    },
    // 更改日期
    dateHandleChange(val) { },
    // 格式化日期
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份补0
      const day = String(date.getDate()).padStart(2, "0"); // 日期补0
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    getCurrentSemesterStart() {
      const now = new Date();
      const year = now.getFullYear();
      // 判断当前是春季还是秋季学期
      if (now.getMonth() >= 2 && now.getMonth() <= 7) {
        // 3月~8月是春季学期
        return this.formatDate(new Date(year, 2, 1)); // 3月1日（月份从0开始计数）
      } else {
        // 如果当前是1-2月，则属于去年的秋季学期
        const isFirstHalfOfYear = now.getMonth() <= 1;
        return this.formatDate(new Date(isFirstHalfOfYear ? year - 1 : year, 8, 1)); // 9月1日
      }
    },
    // 模版下载
    templateDownload() {
      var a = document.createElement("a");
      a.href = window.location.protocol + "//school.striveing.com/web/template/副本分数导入模板.xlsx";
      a.download = "副本分数导入模板.xlsx";
      document.body.appendChild(a);
      a.click();
    },
    // 保留小数 value:值 n:保留位数
    roundFun(value, n) {
      return Math.round(value * Math.pow(10, n)) / Math.pow(10, n);
    },
    // 公共接口调用方法
    publicClassResources(params) {
      this.resourceTotal = 0; // 资源总数
      this.examitemTotal = 0; // 考试题目总数
      this.examTotal = 0; // 考试总数
      // 资源列表数据
      this.combinedData = [];
      resourceList(params).then((res) => {
        for (let i in res.data.datas) {
          // 获取echarts图表数据
          if (res.data.datas[i].types == "assets") {
            this.resourceTotal++;
            this.preData[0].countLength = "{totalText|共计}" + "\n" + "{totalText|" + this.resourceTotal + "个}";
          } else if (res.data.datas[i].types == "examitem") {
            this.examitemTotal++;
            this.preData[1].countLength = "{totalText|共计}" + "\n" + "{totalText|" + this.examitemTotal + "题}";
          } else if (res.data.datas[i].types == "exam") {
            this.examTotal++;
            this.preData[9].countLength = "{totalText|共计}" + "\n" + "{totalText|" + this.examTotal + "个}";
          }
          if (res.data.datas[i].assets) {
            let publicRes = res.data.datas[i].assets;
            publicRes.created = publicRes.created.substring(0, 10); // 转换日期格式
            publicRes.score = publicRes.score + "分"; // 转换分数格式
            if (publicRes.types == "video") {
              this.preData[0].typeList[0].value++;
              publicRes.types = "视频资源";
            } else if (publicRes.types == "audio") {
              this.preData[0].typeList[1].value++;
              publicRes.types = "音频资源";
            } else if (publicRes.types == "doc") {
              this.preData[0].typeList[2].value++;
              publicRes.types = "文档资源";
            } else if (publicRes.types == "image") {
              this.preData[0].typeList[3].value++;
              publicRes.types = "图片资源";
            } else if (publicRes.types == "web") {
              this.preData[0].typeList[4].value++;
              publicRes.types = "资源链接";
            } else if (publicRes.types == "h5") {
              this.preData[0].typeList[4].value++;
              publicRes.types = "特殊互动";
            }
            this.combinedData.push(res.data.datas[i].assets); // 获取列表数据
          } else if (res.data.datas[i].exam_item) {
            let publicRes = res.data.datas[i].exam_item;
            publicRes.created = publicRes.created.substring(0, 10); // 转换日期格式
            publicRes.name = publicRes.content.replace(/<[^>]+>/g, ""); // 转换名字格式
            publicRes.score = publicRes.score + "分"; // 转换分数格式
            if (publicRes.types == "single") {
              this.preData[1].typeList[0].value++;
              publicRes.types = "单选题";
            } else if (publicRes.types == "multi") {
              this.preData[1].typeList[1].value++;
              publicRes.types = "多选题";
            } else if (publicRes.types == "truefalse") {
              this.preData[1].typeList[2].value++;
              publicRes.types = "判断题";
            } else if (publicRes.types == "answer") {
              this.preData[1].typeList[3].value++;
              publicRes.types = "简答题";
            }
            this.combinedData.push(res.data.datas[i].exam_item); // 获取列表数据
          } else if (res.data.datas[i].exam) {
            let publicRes = res.data.datas[i].exam;
            publicRes.created = publicRes.created.substring(0, 10); // 转换日期格式
            publicRes.score = publicRes.score + "分"; // 转换分数格式
            publicRes.num_item = publicRes.num_item + "道"; // 转换题数格式
            if (publicRes.types == "manual") {
              this.preData[9].typeList[0].value++;
              publicRes.types = "手动";
            } else if (publicRes.types == "auto") {
              this.preData[9].typeList[1].value++;
              publicRes.types = "自动";
            }
            this.combinedData.push(res.data.datas[i].exam); // 获取列表数据
          }
        }
        this.beforeClassList = [];
        this.middleClassList = [];
        this.afterClassList = [];
        for (let i in this.combinedData) {
          if (this.combinedData[i].usage == "front") {
            this.beforeClassList.push(this.combinedData[i]); // 课前准备数据获取
          } else if (this.combinedData[i].usage == "middle") {
            this.middleClassList.push(this.combinedData[i]); // 课堂教学数据获取
          } else if (this.combinedData[i].usage == "back") {
            this.afterClassList.push(this.combinedData[i]); // 课后巩固数据获取
          }
        }
        // console.log(this.combinedData);
        // console.log("课前准备数据:", this.beforeClassList);
        // console.log("课堂教学数据:", this.middleClassList);
        // console.log("课后巩固数据:", this.afterClassList);
      });
    },
    // 选择tab类型
    selectTheTypeOfTab(type) {
      this.nameValue = "";
      this.publicGettingDataFunc(type);
      this.examScoreType = type; // 获取作业类型
      if (type == "course") {
        this.scoreType = "coursePointsPage1";
        // 资源列表提交的参数
        let params = {
          lesson_id: this.$store.state.courseDetails.id,
          lesson_item_id: this.classNumberValue,
          types: "",
          page: 1,
          num: 10000,
          // groupby: false,
        };
        this.publicClassResources(params);
      } else {
        this.scoreType = "testPaperForm";
      }
    },
    // 班级选择器
    classHandleChange(value) {
      this.classValue[1] = value[1]; // 获取班级id
      const arr = this.teachingClass.filter((item) => item.id === value[1]);
      this.currentGrade = arr[0].grade; // 获取当前年级
      this.currentClass = arr[0].name; // 获取当前班级
      this.classId = value[1];
      this.nameValue = ""; // 重置默认姓名
      // 重置echarts图表数据
      this.resourceTotal = 0; // 重置资源总数
      this.examitemTotal = 0; // 重置资源总数
      this.examTotal = 0; // 重置资源总数
      this.averageScore1 = 0; // 重置平时表现分平均分
      this.averageScore2 = 0; // 重置期中考试平均分
      this.averageScore3 = 0; // 重置期末考试分平均分
      this.preData = JSON.parse(this.deepCopyPreData); // 重置echarts图表数据
      this.publicGettingDataFunc(this.examScoreType); // 调用获取数据方法
      if (this.examScoreType == "course") {
        // 资源列表提交的参数
        let params = {
          lesson_id: this.$store.state.courseDetails.id,
          lesson_item_id: this.classNumberValue,
          types: "",
          page: 1,
          num: 10000,
          // groupby: false,
        };
        this.publicClassResources(params);
      }
    },
    // 课次选择器
    classTimesHandleChange(value) {
      // 重置echarts图表的数据
      this.resourceTotal = 0; // 清空资源总数
      this.examitemTotal = 0; // 清空资源总数
      this.examTotal = 0; // 清空资源总数
      this.preData[0].countLength = "{totalText|共计}" + "\n" + "{totalText|" + 0 + "个}";
      this.preData[1].countLength = "{totalText|共计}" + "\n" + "{totalText|" + 0 + "题}";
      this.preData[2].countLength = "{totalText|共计}" + "\n" + "{totalText|" + 0 + "个}";
      this.preData[0].typeList[0].value = 0;
      this.preData[0].typeList[1].value = 0;
      this.preData[0].typeList[2].value = 0;
      this.preData[0].typeList[3].value = 0;
      this.preData[0].typeList[4].value = 0;
      this.preData[1].typeList[0].value = 0;
      this.preData[1].typeList[1].value = 0;
      this.preData[1].typeList[2].value = 0;
      this.preData[1].typeList[3].value = 0;
      this.preData[9].typeList[0].value = 0;
      this.preData[9].typeList[1].value = 0;
      if (this.scoreType == "coursePointsPage1" || this.scoreType == "coursePointsPage2") {
        if (value == 0) {
          this.scoreType = "coursePointsPage1";
        } else {
          this.scoreType = "coursePointsPage2";
        }
      }
      this.classNumberValue = value; // 获取课次id
      this.publicGettingDataFunc("course"); // 调用获取数据方法
      // if (this.scoreType == "coursePointsPage4") {
      // 资源列表提交的参数
      let params = {
        lesson_id: this.$store.state.courseDetails.id,
        lesson_item_id: this.classNumberValue,
        types: "",
        page: 1,
        num: 10000,
        // groupby: false,
      };
      this.publicClassResources(params);
      // }
    },
    // 姓名选择器
    nameHandleChange(name) {
      if (this.examScoreType == "course") {
        if (name.value != 0) {
          this.scoreType = "coursePointsPage3";
        } else {
          this.scoreType = "coursePointsPage1";
        }
      }
      this.nameValue = name.label;
      this.nameID = name.value;
      if (this.scoreType == "examinationData") {
        this.viewDetailsOfTheTestPaper(name.value);
      } else {
        this.publicGettingDataFunc(this.examScoreType); // 调用获取数据方法
      }
    },
    // 查看详情 参数:类型 姓名 课次
    detail(type, name, classNum, studentID) {
      // console.log(type);
      this.nameValue = name; // 获取默认姓名
      if (type == "coursePointsPage1") {
        this.scoreType = "coursePointsPage3";
        this.nameID = studentID;
        this.publicGettingDataFunc("course"); // 调用获取数据方法
      } else if (type == "coursePointsPage2") {
        this.scoreType = "coursePointsPage3";
        this.nameID = studentID;
        this.publicGettingDataFunc("course"); // 调用获取数据方法
      } else if (type == "coursePointsPage3") {
        this.classNumberValue = classNum; // 获取课次id
        this.scoreType = "coursePointsPage4";
        // 列表提交的参数
        let params = {
          lesson_id: this.$store.state.courseDetails.id,
          lesson_item_id: this.classNumberValue,
          types: "",
          page: 1,
          num: 10000,
        };
        this.publicClassResources(params);
      }
    },
    // 课堂表现计数器绑定值被改变时触发
    performanceScoreHandleChange(value) {
      console.log(value);
    },

    // 签到
    pageCheckEv(scope) {
      console.log(scope);
    },

    // 上传分数
    uploadTable() {
      this.formFile = ""; // 清空上传表格的文件路径
      this.showBatchUpload = true;
      this.showImportTips = false;
      if (this.examScoreType == "usually") {
        this.batchUploadTitle = "平时表现分上传";
      } else if (this.examScoreType == "mid") {
        this.batchUploadTitle = "期中考试分数上传";
      } else if (this.examScoreType == "final") {
        this.batchUploadTitle = "期末考试分数上传";
      }
    },

    // 作业表格导入
    btnScoreImport() {
      let input = document.createElement("input"); // 创建一个input标签
      document.body.appendChild(input);
      input.style.display = "none";
      input.type = "file"; // 类型改成file 上传文件
      input.accept = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"; // 接受类型
      input.click(); // 触发点击事件 调起文件夹
      input.onchange = (event) => {
        if (!event.target.files || !event.target.files[0]) {
          reject("未选择文件");
        } else {
          let files = event.target.files[0]; // 文件路径
          // 文件流转Base64
          filetoBase64(files).then((base64) => {
            this.showImportTips = true;
            this.formFile = base64;
          });
        }
      };
    },

    // 上传分数确定按钮
    btnPopAffirm() {
      var protocolStr = document.location.protocol; // 判断是http还是https
      if (!this.formFile) {
        Toast("请上传表格！");
      } else {
        this.loading = true;
        let formData = new FormData();
        let str1 = base64toFile(this.formFile, "file"); //base64图片格式转文件流
        formData.append("file", str1); // 加入文件流参数
        formData.append("lesson_id", this.$store.state.courseDetails.id); // 加入课程id
        if (this.batchUploadTitle == "平时表现分上传") {
          formData.append("types", "active"); // 加入导入数据类型
        } else if (this.batchUploadTitle == "期中考试分数上传") {
          formData.append("types", "middle"); // 加入导入数据类型
        } else if (this.batchUploadTitle == "期末考试分数上传") {
          formData.append("types", "back"); // 加入导入数据类型
        }
        axios
          .post(store.state.interfacePath + "api/import/score", formData, {
            headers: {
              "user-token": this.$store.state.loginRecord.data.ext,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            let res = response.data;
            if (res.code == 0) {
              this.loading = false;
              this.showBatchUpload = false;
              // 调用获取表现分、期中考试分数、期末考试分数列表接口
              getScoreList().then((res) => {
                this.scoreList = res.data.datas;
              });
              // 重置echarts图表数据
              this.resourceTotal = 0; // 重置资源总数
              this.examitemTotal = 0; // 重置资源总数
              this.averageScore1 = 0; // 重置平时表现分平均分
              this.averageScore2 = 0; // 重置期中考试平均分
              this.averageScore3 = 0; // 重置期末考试分平均分
              this.preData = JSON.parse(this.deepCopyPreData); // 重置echarts图表数据
              this.publicGettingDataFunc(this.examScoreType); // 调用获取数据方法
              // Toast("已上传:" + res.ext.insert + "   " + "已更新:" + res.ext.update);
            } else {
              Toast(res.ext);
            }
          })
          .catch((response) => {
            // console.log(response);
          });
      }
    },
    // 选择全部班级
    selectAllClass() {
      this.checkAll = !this.checkAll;
      if (this.checkAll) {
        this.checkedClassNumber = this.classNumberOptions1;
      } else {
        this.checkedClassNumber = [];
      }
    },

    // 导出数据方法
    btnDataExport() {
      if (this.checkedClassNumber.length == 0) return;
      this.loading = true;
      // 调用课次习题学生记录接口
      let params = { lesson_id: this.$store.state.courseDetails.id, class_id: this.classValue[1], types: "" };
      courseLearningRecords(params).then((res) => {
        let exportTableData = [];
        // 获取学生表格数据
        for (let i in res.data.ext.users) {
          exportTableData.push({});
          // 获取学生数据列表数据
          let publicRes = res.data.ext.users[i];
          exportTableData[i]["姓名"] = publicRes.name; // 获取学生姓名
          exportTableData[i]["学号"] = publicRes.account; // 获取学号
          exportTableData[i]["年级"] = res.data.ext.class.grade; // 获取年级
          exportTableData[i]["班级"] = res.data.ext.class.name; // 获取班级
          for (let j in this.checkedClassNumber) {
            exportTableData[i][this.checkedClassNumber[j].label] = 0; // 获取学生姓名
            for (let k in res.data.ext.lesson_user) {
              let publicLesson = res.data.ext.lesson_user[k];
              if (publicRes.account == publicLesson.user_account) {
                if (publicLesson.lesson_item_id == this.checkedClassNumber[j].value) {
                  exportTableData[i][this.checkedClassNumber[j].label] += publicLesson.score; // 计算单个课程积分
                }
              }
            }
          }
        }
        import("@/vendor/Export2Excel").then((excel) => {
          const tHeader = ["学生名称", "学号", "年级", "班级"];
          let names = this.checkedClassNumber.map((item) => item.label);
          tHeader.push(...names);
          const filterVal = ["姓名", "学号", "年级", "班级"];
          filterVal.push(...names);
          const list = exportTableData;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            autoWidth: true,
            filename: "学生课次评分表",
          });
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === "timestamp") {
            import("@/vendor/Export2Excel").then((excel) => {
              return excel.parseTime(v[j]);
            });
          } else {
            this.checkedClassNumber = [];
            this.loading = false;
            this.checkAll = false;
            return v[j];
          }
        })
      );
    },
    // 选择课次
    selectClassNum(item) {
      if (this.checkedClassNumber.indexOf(item) === -1) {
        this.checkedClassNumber.push(item);
      } else {
        this.checkedClassNumber.splice(this.checkedClassNumber.indexOf(item), 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100%;
  display: flex;
}

.main-content {
  width: 100%;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.11);
  border-radius: 10px;
}

.pointsDetails-top {
  width: 100%;
  padding: 23px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #bfbfbf;
}

.separate {
  margin-left: 40px;
  margin-right: 40px;
  width: 1px;
  height: 40px;
  background: #bfbfbf;
}

.selector-txt {
  margin-right: 13px;
  font-size: 24px;

  font-weight: 400;
  color: #000000;
}

.detail {
  font-size: 18px;

  font-weight: 400;
  color: #349afe;
}

.pointsDetails-content {
  flex: 1;
  padding: 30px 83px;
  box-sizing: border-box;
  overflow: auto;
}

.resourceList-h1Box {
  width: 1536px;
  height: 72px;
  background: rgba(52, 154, 254, 0.25);
  display: flex;
  align-items: center;
  padding: 20px 24px;
  box-sizing: border-box;
}

.resourceList-block {
  width: 15px;
  height: 31px;
  background: #3096fb;
}

.resourceList-h1 {
  margin-left: 23px;
  font-size: 29px;

  font-weight: 400;
  color: #000000;
}

.resourceList-h2Box {
  width: 1536px;
  height: 60px;
  background: #eaeaea;
  display: flex;
  align-items: center;
  padding: 19px 37px;
  box-sizing: border-box;
}

.resourceList-round {
  width: 12px;
  height: 12px;
  background: #3096fb;
  border-radius: 50%;
}

.resourceList-h2 {
  margin-left: 28px;
  font-size: 22px;

  font-weight: 400;
  color: #000000;
}

.pop-batchUpload {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 101;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.resourcesBatchUpload-content {
  position: relative;
  width: 761px;
  background: #ffffff;
  border-radius: 20px;
  padding: 22px 56px;
  box-sizing: border-box;
}

.batchUpload-title {
  font-size: 26px;

  font-weight: 400;
  color: #349afe;
  text-align: center;
}

.requiredIcon {
  width: 10px;
  height: 10px;
  color: #ff0000;
}

.informationTxt {
  font-size: 22px;

  font-weight: 400;
  color: #555555;
}

.informationTips {
  font-size: 16px;

  font-weight: 400;
  color: #b6b6b6;
}

.btnPopAffirm {
  width: 200px;
  height: 50px;
  background: #349afe;
  border-radius: 10px;
  font-size: 28px;

  font-weight: 400;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.main-content-right {
  width: 491px;
  margin-left: 35px;
}

.btnClose {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 23px;
  height: 23px;
}

.submitSuccessfully {
  position: absolute;
  top: 0;
  width: 135px;
  height: 95px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.5);
  pointer-events: none;
}

.btnDataExport {
  margin-top: 20px;
  width: 107px;
  height: 19px;
  cursor: pointer;
}

.classNumberTxt {

  font-weight: 400;
  font-size: 18px;
  color: #555555;
}

.classNumberTxtBox {
  height: 418px;
  overflow: auto;
}

.gradediv_classimg {
  width: 20px;
  height: 20px;
  margin-right: 20px;
}

.classNumberTxtBoxItem {
  margin-bottom: 22px;
}

.boxImport {
  position: relative;
  width: 135px;
  height: 95px;
}

.submitSuccessfullyImg {
  width: 40px;
  height: 40px;
}

.templateDownload {
  width: 107px;
  height: 19px;
}

.icon1 {
  width: 153px;
  height: 24px;
}

.icon2 {
  width: 165px;
  height: 24px;
}

.icon3 {
  width: 190px;
  height: 24px;
}

.icon4 {
  width: 190px;
  height: 24px;
}

.icon5 {
  width: 189px;
  height: 24px;
}

.uploadDailyPerformanceScore {
  width: 166px;
  height: 18px;
}

.uploadExamScores {
  width: 146px;
  height: 19px;
}

.pop-answerTheTestPaperDetails {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
}

.answerTheTestPaperDetails-box {
  position: relative;
  width: 1277px;
  height: 805px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.11);
  border-radius: 10px;
  padding: 36px 30px;
  box-sizing: border-box;
}

.answerTheTestPaperDetails-title {

  font-weight: 400;
  font-size: 22px;
  color: #349afe;
}

.answerTheTestPaperDetails-title1 {
  margin-top: 30px;

  font-weight: 400;
  font-size: 22px;
  color: #349afe;
}

.testPaperInformation-box {
  padding: 15px 20px;
  box-sizing: border-box;
  border-bottom: 1px solid #bfbfbf;
}

.testPaperInformationTxt {

  font-weight: 400;
  font-size: 22px;
  color: #555555;
  line-height: 52px;
  margin-left: 10px;
}

/* 习题列表 */
.exampleList {
  width: 1218px;
  padding: 20px 30px;
  box-sizing: border-box;
  border-bottom: 1px solid #bfbfbf;
}

.exampleList1 {
  padding: 20px 30px;
  box-sizing: border-box;
  border-bottom: 1px solid #bfbfbf;
}

.topicType {
  margin-left: 32px;
  height: 25px;
  font-size: 18px;

  font-weight: 400;
  color: #999999;
}

.questionNo {
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 12px;
}

.stem {
  margin-top: 15px;
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 23px;
}

.exampleList-option {
  margin-top: 15px;
  margin-left: 50px;
  border-left: 4px solid #dddddd;
  padding-left: 15px;
}

.exampleList-option-txt {
  font-size: 14px;

  font-weight: 400;
  color: #000000;
  line-height: 23px;
}

.answer {
  margin-top: 14px;
}

.answer-txt {
  font-size: 18px;

  font-weight: 400;
  color: #349afe;
}

.blankAnswer {
  margin-left: 10px;
  font-size: 18px;

  font-weight: 400;
  color: #349afe;
}

.answer-English {
  margin-left: 12px;
  font-size: 18px;

  font-weight: 400;
  color: #349afe;
}

.score-inputFrame {
  margin-left: 9px;
  width: 50px;
  height: 24px;
  border: 1px solid #757575;
  border-radius: 5px;
}

.score-input {
  font-size: 18px;

  font-weight: 400;
  color: #349afe;
  width: 50px;
  height: 24px;
  border: 1px solid #757575;
  border-radius: 10px;
  text-align: center;
  background-color: transparent;
  border: 0px;
  outline: none;
}

.score-txt {
  font-size: 18px;

  font-weight: 400;
  color: #555555;
}
</style>
